import { dtoVersConge } from '../../api/mappers';
import { congesApi } from '../../api/resources';

/**
 * Approuve ou refuse une demande de congé par le serveur, sans renvoyer ses dates.
 *
 * <p>Le ✓ réécrivait toute la demande depuis la copie de l'écran : sur une
 * demande dont l'employé venait d'accepter la date proposée, il remettait les
 * dates d'origine. La décision passe désormais par sa propre route, et la
 * demande revient du serveur telle qu'il l'a enregistrée.
 *
 * @param {object} conge demande concernée
 * @param {boolean} approuve vrai pour approuver, faux pour refuser
 * @param {(fn: (p: object[]) => object[]) => void} setConges mise à jour des demandes
 * @returns {Promise<void>} une fois la décision enregistrée ou l'erreur affichée
 */
export async function decideConge(conge, approuve, setConges) {
  if (!setConges) return;
  const statut = approuve ? 'Approuvé' : 'Refusé';
  if (!Number.isInteger(conge.id)) {
    setConges((p) => p.map((x) => (x.id === conge.id ? { ...x, statut } : x)));
    return;
  }
  try {
    const dto = await (approuve ? congesApi.approuve(conge.id) : congesApi.refuse(conge.id));
    setConges((p) => p.map((x) => (x.id === conge.id ? dtoVersConge(dto) : x)));
  } catch (e) {
    try {
      window.alert(e?.message || 'La décision n’a pas pu être enregistrée. Réessaie.');
    } catch (er) {
      // Pas de fenêtre d'alerte : rien de plus à faire.
    }
  }
}
